import script from "./OverUsViewChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./OverUsViewChoose.vue?vue&type=script&setup=true&lang=js"

import "./OverUsViewChoose.vue?vue&type=style&index=0&id=2fc24526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc24526"]])

export default __exports__